import { createRoot } from "react-dom/client";
import { GeolocationProvider } from "./contexts/GeolocationContext";
import { GlobalErrorHandler, setupGlobalErrorHandlers } from "./components/GlobalErrorHandler";
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n"; // Import i18n synchronously (non-blocking)
import { preloadCriticalData } from "./services/preloadService";
import { registerServiceWorker } from "./registerServiceWorker";
import { setupChunkErrorHandler } from "./utils/chunkErrorHandler";

// Setup chunk error handler first to catch loading failures
setupChunkErrorHandler();

// Setup global error handlers
setupGlobalErrorHandlers();

// Render immediately - don't block on i18n initialization
const root = createRoot(document.getElementById("root")!);
root.render(
  <GlobalErrorHandler>
    <GeolocationProvider>
      <App />
    </GeolocationProvider>
  </GlobalErrorHandler>
);

// Preload critical data in background
preloadCriticalData();

// Register service worker after render
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    registerServiceWorker();
  });
} else {
  setTimeout(() => {
    registerServiceWorker();
  }, 1);
}
